<template>
  <div id="app">
  
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>
	*{
		margin: 0px;
		padding:0px;
	}
	body{
		background: #f4f4f4;
	}
</style>



// WEBPACK FOOTER //
// App.vue?0ad534e5